import { isNotEmpty } from '@doltech/utils/lib/text';
import { isEmpty } from 'lodash';
import { Node, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

import { findAboveByType, findBellowByType } from '../../../DolEditor/helpers/node';
import { PARAGRAPH_TOGGLE } from '../../plugins-common/ParagraphToggle/types';
import {
  EXERCISE_SHORT_ANSWER_BLANK,
  EXERCISE_SHORT_ANSWER_QUESTION,
  SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES,
} from './types';
import { createShortAnswerBlank } from './utils';

export const withShortAnswer =
  () =>
  <T extends ReactEditor>(editor: T) => {
    const { normalizeNode } = editor;

    editor.normalizeNode = (entry) => {
      const [node] = entry;
      const [paragraphToggle, paragraphTogglePath]: any = entry;
      if (paragraphToggle?.type === PARAGRAPH_TOGGLE) {
        const shortAnswerQuestionEntry = findAboveByType(
          editor,
          paragraphTogglePath,
          EXERCISE_SHORT_ANSWER_QUESTION
        );
        if (shortAnswerQuestionEntry) {
          const [question]: any = shortAnswerQuestionEntry;

          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const isExplain = node.present === SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.EXPLANATION;
          const hasNoBlank =
            findBellowByType(editor, paragraphTogglePath, EXERCISE_SHORT_ANSWER_BLANK).length === 0;
          const blankPath = paragraphTogglePath.concat(0, 1);

          // add
          if (isNotEmpty(Node.string(paragraphToggle)) && hasNoBlank && !isExplain) {
            Transforms.insertNodes(editor, createShortAnswerBlank(question.blankId), {
              at: blankPath,
            });
            return;
          }

          // remove
          if (isEmpty(Node.string(paragraphToggle)) && !hasNoBlank) {
            Transforms.removeNodes(editor, {
              at: blankPath,
            });
            return;
          }
        }
      }
      normalizeNode(entry);
    };

    return editor;
  };
